import {VehicleAddonResponseType} from "@CheckOrder/api/types/GetAddonDataQuery.type";
import useGetVehicleTotalPrice
    from "@CheckOrder/features/addons/features/jadrolinija/features/vehicleType/hooks/useGetVehicleTotalPrice";
import useCurrency from "@Currency/hooks/useCurrency";

export default function useGetSelectedVehicleTypeLabel(
    selectOptions: { value: number, label: string, activeGroup: VehicleAddonResponseType }[],
    activeOption: { value: number, label: string, activeGroup: VehicleAddonResponseType }
) {
    const {getAddonPrice} = useGetVehicleTotalPrice()
    const {sign} = useCurrency()

    const getActiveLabel = () => {
        const selectedOption = selectOptions.find((option) => (
            option.value === activeOption.value
        ))

        const price = getAddonPrice(selectedOption.value)

        return `${selectedOption.label} (+${price}${sign})`
    }

    return {
        getActiveLabel,
    }
}